import { appModule } from "@/store/modules/app";
import { join, values, mapValues } from "lodash";

class ErrorAlert {
  showSnackAlert(e, pesan) {
    let dt = e.response;
    let message = "";
    if (dt['status'] == 422) {
      message = join(
        values(
          mapValues(e.response.data.errors, function (val) {
            return join(val, "; ");
          })
        ),
        "; "
      );
      dt = { status: 0, err: "Gagal Ambil Data " + pesan + " ERROR 422 : " + e.response.data.message + " (" + message + ")" }
      // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
    } else {
      dt = { data: dt, status: dt['status'], err: "Gagal Ambil Data " + pesan + " ERROR " + e.response.status + " : " + e.response.data.message }
    }
    appModule.NoticeDelayAlert(dt.err);
  }

  showErrorAlert(e) {
    let dt = e.response;
    let message = "";
    if (dt['status'] == 422) {
      message = join(
        values(
          mapValues(e.response.data.errors, function (val) {
            return join(val, "; ");
          })
        ),
        "; "
      );
      dt = { status: 0, err: "ERROR 422 : " + e.response.data.message + " (" + message + ")" }
      // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
    } else {
      dt = { data: dt, status: dt['status'], err: "ERROR " + e.response.status + " : " + e.response.data.message }
    }
    // appModule.NoticeDelay(dt.err);
    appModule.sendErrorAlert(dt.err);
  }
}

export default new ErrorAlert();
